import { render, staticRenderFns } from "./SmsAuditDetail.vue?vue&type=template&id=66c71f92&"
import script from "./SmsAuditDetail.vue?vue&type=script&lang=js&"
export * from "./SmsAuditDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports